<template>
  <div class="pharma-login-page">
  <div class="login-left-panel">
    <div class="login-left-orbs" aria-hidden="true">
      <span class="login-orb login-orb--1" />
      <span class="login-orb login-orb--2" />
      <span class="login-orb login-orb--3" />
    </div>
    <div class="login-left-content">
      <div class="brand-row">
        <div class="brand-logo-wrap">
          <v-img
            class="brand-logo"
            contain
            max-height="26px"
            max-width="26px"
            src="@/assets/img/image.png"
          />
        </div>
        <div class="brand-text">
          <span class="brand-name">PharmaWRK</span>
          <span class="brand-tagline">Field Force Management</span>
        </div>
      </div>

      <div class="hero-copy">
        <h1 class="hero-title">
          Transform field operations into
          <span class="hero-highlight">business growth</span>
        </h1>
        <p class="hero-subtitle">
          Manage visits, POVs, samples, CME, territories, reports and analytics
          from a single intelligent platform built for pharmaceutical teams.
        </p>
      </div>

      <div class="med-feature-card">
        <div class="med-card-decor">
          <span class="med-pill med-pill--1" />
          <span class="med-pill med-pill--2" />
          <span class="med-capsule med-capsule--1" />
          <span class="med-cross" />
        </div>

        <div class="med-card-header">
          <div class="med-badge">
            <iconify-icon icon="tabler:medical-cross" width="22" class="med-badge-icon" />
          </div>
          <div>
            <h3 class="med-card-title">Built for Pharma Field Teams</h3>
            <p class="med-card-subtitle">
              Samples, visits, and medical literature in one place.
            </p>
          </div>
        </div>

        <div class="med-feature-grid">
          <div class="med-feature-chip">
            <div class="med-chip-icon">
              <iconify-icon icon="tabler:pill" width="16" class="med-chip-iconify" />
            </div>
            <div>
              <span class="med-chip-label">Samples & drugs</span>
              <span class="med-chip-desc">Track samples and drug literature</span>
            </div>
          </div>
          <div class="med-feature-chip">
            <div class="med-chip-icon">
              <iconify-icon icon="tabler:stethoscope" width="16" class="med-chip-iconify" />
            </div>
            <div>
              <span class="med-chip-label">Doctor visits</span>
              <span class="med-chip-desc">Log POVs and field visits on the go</span>
            </div>
          </div>
          <div class="med-feature-chip">
            <div class="med-chip-icon">
              <iconify-icon icon="tabler:book-2" width="16" class="med-chip-iconify" />
            </div>
            <div>
              <span class="med-chip-label">CME & learning</span>
              <span class="med-chip-desc">Share medical content with HCPs</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="login-right-panel">
    <div class="login-right-grid" aria-hidden="true" />
    <div class="login-right-glow login-right-glow--1" />
    <div class="login-right-glow login-right-glow--2" />
    <div class="login-right-glow login-right-glow--3" />
    <div class="login-form-area">
      <SignIn :sign_in_dialog="true" @clicked="SignInDialogEmit" />
    </div>
    <p class="login-footer">© 2026 PharmaWRK. All rights reserved.</p>
  </div>
  </div>
</template>

<script>
import SignIn from "@/components/LoginPage/SignIn.vue";
import AboutSection from "@/components/LoginPage/AboutSection.vue";
import ContactSection from "@/components/LoginPage/ContactSection.vue";
import DownloadSection from "@/components/LoginPage/DownloadSection.vue";
import Footer from "@/components/LoginPage/Footer.vue";
import HomeSection from "@/components/LoginPage/HomeSection.vue";
import Navigation from "@/components/LoginPage/Navigation.vue";

export default {
  components: {
    SignIn,
    AboutSection,
    ContactSection,
    DownloadSection,
    Footer,
    HomeSection,
    Navigation,
  },
  methods: {
    SignInDialogEmit() {
      // kept for SignIn emit compatibility
    },
  },
};
</script>

<style scoped>
.pharma-login-page {
  display: flex;
  min-height: 100vh;
  width: 100%;
  font-family: "DM Sans", system-ui, sans-serif;
}

.login-left-panel {
  flex: 1;
  min-width: 0;
  background: linear-gradient(
    155deg,
    #087a62 0%,
    #0c9f6b 38%,
    #0bb87a 72%,
    #0fc566 100%
  );
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 36px 40px;
}

.login-left-orbs {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.login-orb {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.22) 0%,
    rgba(255, 255, 255, 0.04) 70%
  );
  border: 1px solid rgba(255, 255, 255, 0.12);
  animation: login-float 8s ease-in-out infinite;
}

.login-orb--1 {
  width: 280px;
  height: 280px;
  top: -80px;
  right: -60px;
  animation-delay: 0s;
}

.login-orb--2 {
  width: 160px;
  height: 160px;
  bottom: 10%;
  left: -40px;
  animation-delay: -3s;
}

.login-orb--3 {
  width: 100px;
  height: 100px;
  top: 42%;
  right: 18%;
  animation-delay: -5s;
  opacity: 0.7;
}

@keyframes login-float {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-14px) scale(1.03);
  }
}

.login-left-panel::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.08) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(255, 255, 255, 0.06) 0%,
      transparent 40%
    );
  pointer-events: none;
}

.login-left-panel::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 60px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  bottom: 18%;
  right: 12%;
  transform: rotate(-25deg);
  pointer-events: none;
}

.login-left-content {
  position: relative;
  z-index: 1;
  max-width: 520px;
  color: white;
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 36px;
}

.brand-logo-wrap {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 1);
}

.brand-logo {
  border-radius: 4px;
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-family: "Sora", "DM Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.brand-tagline {
  font-size: 12px;
  opacity: 0.85;
  font-weight: 400;
}

.hero-copy {
  margin-bottom: 32px;
}

.hero-title {
  font-family: "Sora", "DM Sans", sans-serif;
  font-size: clamp(26px, 3.2vw, 36px);
  font-weight: 600;
  line-height: 1.24;
  margin-bottom: 14px;
  letter-spacing: -0.02em;
}

.hero-highlight {
  display: inline-block;
  position: relative;
  font-style: normal;
}

.hero-highlight::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2px;
  height: 10px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  z-index: -1;
}

.hero-subtitle {
  font-size: 14px;
  line-height: 1.55;
  opacity: 0.9;
  font-weight: 400;
}

.med-feature-card {
  position: relative;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 18px;
  padding: 20px 22px 18px;
  box-shadow:
    0 20px 50px rgba(8, 50, 38, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
  overflow: hidden;
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}

.med-feature-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 24px 56px rgba(8, 50, 38, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.med-card-decor {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.med-pill {
  position: absolute;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.med-pill--1 {
  width: 48px;
  height: 18px;
  top: 12px;
  right: 24px;
  transform: rotate(35deg);
}

.med-pill--2 {
  width: 32px;
  height: 12px;
  bottom: 20px;
  right: 40px;
  transform: rotate(-20deg);
  opacity: 0.7;
}

.med-capsule {
  position: absolute;
  width: 14px;
  height: 28px;
  border-radius: 999px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.08) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.med-capsule--1 {
  top: 50%;
  right: 16px;
  transform: translateY(-50%) rotate(15deg);
  opacity: 0.5;
}

.med-cross {
  position: absolute;
  top: 18px;
  right: 80px;
  width: 20px;
  height: 20px;
  opacity: 0.15;
}

.med-cross::before,
.med-cross::after {
  content: "";
  position: absolute;
  background: white;
  border-radius: 2px;
}

.med-cross::before {
  width: 20px;
  height: 4px;
  top: 8px;
  left: 0;
}

.med-cross::after {
  width: 4px;
  height: 20px;
  left: 8px;
  top: 0;
}

.med-card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.med-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.med-card-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1.3;
}

.med-card-subtitle {
  font-size: 13px;
  opacity: 0.85;
  line-height: 1.45;
}

.med-feature-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.med-feature-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  transition: background 0.25s ease, transform 0.25s ease;
}

.med-feature-chip:hover {
  background: rgba(255, 255, 255, 0.16);
  transform: translateX(4px);
}

.med-chip-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.med-badge-icon,
.med-chip-iconify {
  color: white;
  opacity: 0.95;
}

.med-chip-iconify svg {
  stroke-width: 1.5;
}

.med-chip-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}

.med-chip-desc {
  display: block;
  font-size: 11px;
  opacity: 0.78;
  line-height: 1.35;
}

.login-right-panel {
  flex: 1;
  min-width: 0;
  background: linear-gradient(
    165deg,
    #eef6f2 0%,
    #f8fbf9 35%,
    #edf8f3 65%,
    #e6f4ec 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px;
  position: relative;
  overflow: hidden;
}

.login-right-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(12, 159, 107, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(12, 159, 107, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 40%, black 20%, transparent 75%);
  -webkit-mask-image: radial-gradient(
    ellipse 80% 70% at 50% 40%,
    black 20%,
    transparent 75%
  );
  pointer-events: none;
}

.login-right-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
}

.login-right-glow--1 {
  width: 320px;
  height: 320px;
  background: rgba(12, 159, 107, 0.18);
  top: -80px;
  right: -60px;
}

.login-right-glow--2 {
  width: 280px;
  height: 280px;
  background: rgba(15, 197, 102, 0.14);
  bottom: -60px;
  left: -40px;
}

.login-right-glow--3 {
  width: 200px;
  height: 200px;
  background: rgba(12, 159, 107, 0.12);
  top: 40%;
  left: 30%;
}

.login-form-area {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  animation: login-fade-up 0.7s ease-out;
}

@keyframes login-fade-up {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-footer {
  position: relative;
  z-index: 1;
  margin-top: 24px;
  font-size: 12px;
  color: #8a9199;
}

@media (max-width: 960px) {
  .pharma-login-page {
    flex-direction: column;
  }

  .login-left-panel {
    padding: 32px 28px;
    min-height: auto;
  }

  .hero-copy {
    margin-bottom: 24px;
  }

  .feature-glass-card,
  .med-feature-card {
    display: none;
  }

  .login-right-panel {
    flex: 1;
    padding: 28px 20px 32px;
  }
}

@media (max-width: 480px) {
  .login-left-panel {
    padding: 24px 20px;
  }

  .brand-row {
    margin-bottom: 24px;
  }

  .hero-title {
    font-size: 24px;
  }
}
</style>
